import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative inline-flex" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "rounded-full bg-gray-200 p-1.5" }
const _hoisted_4 = { class: "flex items-center truncate" }
const _hoisted_5 = { class: "ml-2 truncate text-sm font-medium group-hover:text-gray-800" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "ml-1 h-3 w-3 shrink-0 fill-current text-gray-400",
  viewBox: "0 0 12 12"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Профиль", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Выйти", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonOutline = _resolveComponent("PersonOutline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LogOutOutline = _resolveComponent("LogOutOutline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      ref: "trigger",
      class: "group inline-flex items-center justify-center",
      "aria-haspopup": "true",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.dropdownOpen = !_ctx.dropdownOpen), ["prevent"])),
      "aria-expanded": _ctx.dropdownOpen
    }, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.getFirstSymbolUser), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.getUserFio), 1),
        _hoisted_6
      ])
    ], 8, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200 transform",
      "enter-from-class": "opacity-0 -translate-y-2",
      "enter-to-class": "opacity-100 translate-y-0",
      "leave-active-class": "transition ease-out duration-200",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["absolute top-full z-10 mt-1 min-w-44 origin-top-right overflow-hidden rounded border border-gray-200 bg-white p-1.5 shadow-lg", _ctx.align === 'right' ? 'right-0' : 'left-0'])
        }, [
          _createElementVNode("ul", {
            ref: "dropdown",
            onFocusin: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dropdownOpen = true)),
            onFocusout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dropdownOpen = false))
          }, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "flex items-center rounded px-1.5 py-1 text-sm font-medium text-gray-600 transition duration-200 ease-in-out hover:bg-gray-100 hover:text-gray-800",
                to: "/user-profile",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_icon, {
                    size: "16",
                    style: {"margin-right":"6px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PersonOutline)
                    ]),
                    _: 1
                  }),
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                class: "flex items-center rounded px-1.5 py-1 text-sm font-medium text-gray-600 transition duration-200 ease-in-out hover:bg-gray-100 hover:text-gray-800",
                to: "/",
                onClick: _ctx.getLogout
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_icon, {
                    size: "16",
                    style: {"margin-right":"6px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_LogOutOutline)
                    ]),
                    _: 1
                  }),
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ], 544)
        ], 2), [
          [_vShow, _ctx.dropdownOpen]
        ])
      ]),
      _: 1
    })
  ]))
}